import { createElement } from "react";

import { IContractorDTO } from "../../interfaces/IContractorDTO";
import { FiEdit } from "react-icons/fi";
import { LuFileClock } from "react-icons/lu";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { FaBriefcaseMedical } from "react-icons/fa";
import { MdEmail, MdOutlinePendingActions } from "react-icons/md";

interface IContractorListMobileProps {
  contractors: IContractorDTO[];
  searchVal: string;
  active_status: number;
  userType: string;
  handleEdit: (contractor: IContractorDTO) => void;
  handlePTOClicked: (contractor: IContractorDTO) => void;
  // handleRatesClicked: (contractor: IContractorDTO) => void;
  handleAdditionsClicked: (contractor: IContractorDTO) => void;
  handleStatusClicked: (contractor: IContractorDTO) => void;
  handleSendRegistrationEmail: (contractor: IContractorDTO) => void;
  handleSickLeaveClicked: (contractor: IContractorDTO) => void;
  handleRatesManageClicked: (contractor: IContractorDTO) => void;
}

export function ContractorListMobile({
  contractors,
  searchVal,
  active_status,
  userType,
  handleEdit,
  handlePTOClicked,
  // handleRatesClicked,
  handleAdditionsClicked,
  handleStatusClicked,
  handleSendRegistrationEmail,
  handleSickLeaveClicked,
  handleRatesManageClicked,
}: IContractorListMobileProps): JSX.Element {
  return (
    <div
      style={{
        maxHeight: "80vh",
        overflowY: "auto",
        overflowX: "hidden",
        width: "100%",
      }}
    >
      {contractors
        .filter((contractor) =>
          active_status === 1
            ? contractor.is_active
            : active_status === 0
            ? !contractor.is_active
            : true
        )
        .filter((contractor) => {
          if (searchVal.trim() === "") return true;
          // Split searchVal by whitespace, trim, and filter out empty strings
          const searchWords = searchVal
            .split(/\s+/) // split by any whitespace (space, tab, etc.)
            .map((word) => word.trim().toLowerCase())
            .filter(Boolean);
          // Check if ANY word matches ANY field

          return searchWords.every(
            (word) =>
              `${contractor.first_name} ${contractor.second_name} ${contractor.third_name} ${contractor.fourth_name}`
                .toLowerCase()
                .includes(word) ||
              contractor.email.toLowerCase().includes(word) ||
              contractor.plant_name.toLowerCase().includes(word)
          );
        })
        .map((contractor, index, filtered) => (
          <div key={contractor.id}>
            {(index > 0 &&
              filtered[index - 1].plant_id !== contractor.plant_id) ||
            index === 0 ? (
              <div className="tw-flex tw-justify-start tw-text-sm tw-mb-2 tw-pl-2 tw-bg-gray-200">
                <h1>{contractor.plant_name}</h1>
              </div>
            ) : null}
            <div className="tw-border tw-rounded-lg tw-p-4 tw-mb-4 tw-text-xs tw-shadow-md tw-leading-5 tw-max-w-full tw-overflow-hidden tw-mr-2">
              <div className="tw-flex tw-flex-wrap">
                <strong>Contractor ID:</strong>
                <span className="tw-ml-2 tw-break-all">
                  {contractor.contractor_id}
                </span>
                <span
                  className={`tw-ml-auto tw-text-primary-light ${
                    contractor.is_active ? "tw-text-primary" : "tw-text-red-500"
                  }`}
                >
                  {contractor.is_active ? "(Active)" : "(Inactive)"}
                </span>
              </div>
              <p className="tw-break-words">
                <strong>Name:</strong>{" "}
                {`${contractor.first_name} ${contractor.second_name} ${contractor.third_name} ${contractor.fourth_name}`}
              </p>
              {userType === "super_admin" && (
                <>
                  <p className="tw-break-all">
                    <strong>Email:</strong> {contractor.email}
                  </p>
                  <p>
                    <strong>Phone:</strong> {contractor.phone}
                  </p>
                  <p>
                    <strong>Plant ID:</strong> {contractor.plant_id}
                  </p>
                </>
              )}
              <p className="tw-break-words">
                <strong>Plant Name:</strong> {contractor.plant_name}
              </p>
              <div className="tw-grid tw-grid-cols-3 tw-gap-2 tw-mt-2">
                {userType === "super_admin" && (
                  <>
                    <button
                      className="tw-flex tw-items-center tw-color-primary tw-border tw-rounded-lg tw-p-2 tw-text-xs tw-bg-gray-200"
                      onClick={() => handleEdit(contractor)}
                    >
                      {createElement(
                        FiEdit as React.ComponentType<{ size?: number }>,
                        { size: 14 }
                      )}
                      <span className="tw-ml-1">Edit</span>
                    </button>
                    <button
                      className="tw-flex tw-items-center tw-color-primary tw-border tw-rounded-lg tw-p-2 tw-text-xs tw-bg-gray-200"
                      onClick={() => handlePTOClicked(contractor)}
                    >
                      {createElement(
                        LuFileClock as React.ComponentType<{ size?: number }>,
                        { size: 14 }
                      )}
                      <span className="tw-ml-1">PTO</span>
                    </button>
                    {/* <button
                      className="tw-flex tw-items-center tw-color-primary tw-border tw-rounded-lg tw-p-2 tw-text-xs tw-bg-gray-200"
                      onClick={() => handleRatesClicked(contractor)}
                    >
                      {createElement(
                        RiMoneyDollarCircleLine as React.ComponentType<{
                          size?: number;
                        }>,
                        { size: 16 }
                      )}
                      <span className="tw-ml-1">Rates</span>
                    </button> */}
                    <button
                      className="tw-flex tw-items-center tw-color-primary tw-border tw-rounded-lg tw-p-2 tw-text-xs tw-bg-gray-200"
                      onClick={() => handleRatesManageClicked(contractor)}
                    >
                      {createElement(
                        RiMoneyDollarCircleLine as React.ComponentType<{
                          size?: number;
                        }>,
                        { size: 16 }
                      )}
                      <span className="tw-ml-1">Rates</span>
                    </button>
                    <button
                      className="tw-flex tw-items-center tw-color-primary tw-border tw-rounded-lg tw-p-2 tw-text-xs tw-bg-gray-200"
                      onClick={() => handleAdditionsClicked(contractor)}
                    >
                      {createElement(
                        RiMoneyDollarCircleLine as React.ComponentType<{
                          size?: number;
                        }>,
                        { size: 16 }
                      )}
                      <span className="tw-ml-1">Additions</span>
                    </button>
                    <button
                      className="tw-flex tw-items-center tw-color-primary tw-border tw-rounded-lg tw-p-2 tw-text-xs tw-bg-gray-200"
                      onClick={() => handleStatusClicked(contractor)}
                    >
                      {createElement(
                        MdOutlinePendingActions as React.ComponentType<{
                          size?: number;
                        }>,
                        { size: 16 }
                      )}
                      <span className="tw-ml-1">Status</span>
                    </button>
                    <button
                      className="tw-flex tw-items-center tw-color-primary tw-border tw-rounded-lg tw-p-2 tw-text-xs tw-bg-gray-200"
                      onClick={() => handleSendRegistrationEmail(contractor)}
                    >
                      {createElement(
                        MdEmail as React.ComponentType<{
                          size?: number;
                        }>,
                        { size: 16 }
                      )}
                      <span className="tw-ml-1">Registration</span>
                    </button>
                  </>
                )}
                <button
                  className="tw-flex tw-items-center tw-color-primary tw-border tw-rounded-lg tw-p-2 tw-text-xs tw-bg-gray-200"
                  onClick={() => handleSickLeaveClicked(contractor)}
                >
                  {createElement(
                    FaBriefcaseMedical as React.ComponentType<{
                      size?: number;
                    }>,
                    { size: 16 }
                  )}
                  <span className="tw-ml-1">Sick Leave</span>
                </button>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
}
